class FortuneRiskClass {
    id!:   number;
    name!: string;
}

export default FortuneRiskClass;